import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

class Tooltip extends Component {
  constructor(props) {
    super(props);
    this.state = {
      active: false,
    };
  }

  onClick = () => {
    this.setState({ active: !this.state.active });
  }

  render() {
    const tooltipClass = classNames('tooltip-container', {
      'tooltip-active': this.state.active,
    });

    const { children, text } = this.props;

    return (
      <div className={tooltipClass}>
        <div className="tooltip-trigger">{children}</div>
        <div className="tooltip">{text}</div>
      </div>
    );
  }
}

Tooltip.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.string]),
  text: PropTypes.string,
};

export default Tooltip;



// WEBPACK FOOTER //
// ./library/app/components/Global/Tooltips/Tooltip.js